'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './role-edit.routes';

export class RoleEditComponent {
  constructor(SettingsService, Auth, $state, $stateParams, dialogs, $uibModal) {
    'ngInject';

    this.SettingsService = SettingsService;

    this.dialogs = dialogs;
    this.$uibModal = $uibModal;

    this.jsonValue = "";
    this.$state = $state;

    this.modules = ["community", "property", "owner", "vendor", "violation","work-order","task","service-request"];

    SettingsService.getByName({name: 'roles-and-permissions'}, settings => {
      this.settings = settings;

      this.rolesData = this.settings.data;
      this.roles = Object.keys(this.rolesData);
      this.data = this.rolesData[this.roles[0]];
    });
  }

  switchData(role) {
    this.data = this.rolesData[role];
  }

  getPathByResourceAndPermType(resource, permType) {
    switch (permType) {
      case 'community':

        switch(resource) {
          case 'violation':
          case 'work-order':
            return "property.community.code";
          case 'property':
            return 'community.code';
          case 'community':
            return 'code';
          default:
            return ''
        }

      default:
        return '';
    }
  }

  permissionEdit(module) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'permissionEdit',
      resolve: {
        config: function() {
          return {
            data: that.data[module]
          }
        }
      },
      size: 'md'
    });

    modalInstance.result.then(
      function (permissions) {

        that.data[module] = permissions;

      },
      function () { /* cancel */ }
    );

  }

  save() {
    var onSuccess = () => {
      var dlg = this.dialogs.notify("Success", "The roles and permissions gave been saved successfully");
      dlg.result.then(() => {});
    };

    var onError = err => {
      var dlg = this.dialogs.error("Error", "There has been an error trying to save the roles and permissions:<br/>"+err.toString());
      console.log(err);
    };

    this.SettingsService.update({id: this.settings._id}, this.settings, onSuccess, onError);
  }
}

export default angular.module('conduu.roleEdit', [uiRouter])
  .config(routes)
  .component('roleEdit', {
    template: require('./role-edit.html'),
    controller: RoleEditComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/admin/role-edit/role-edit.component.js